module.exports = __webpack_public_path__ + "static/media/vasos.5f3108cd.svg";